//* Libraries imports
import { z } from "zod";

//* Schemas imports
import { documentosTiposSchema } from "./documents";

export const enrollmentSchema = z.object({
  id: z.number(),
  cpf: z.string(),
  nomeCompleto: z.string(),
  dataNascimento: z.string().datetime(),
  sexo: z.enum(["M", "F", "O"]),
  rg: z.string().nullable().optional(),
  orgaoEmissor: z
    .string()
    .min(3, "Orgao emissor é obrigatório")
    .nullable()
    .optional(),
  dataExpedicaoRg: z.string().nullable().optional(),
  nomeCompletoMae: z.string(),
  email: z.string().email(),
  celular: z.string(),
  cep: z.string(),
  nomeRua: z.string(),
  numero: z.string().nullable(),
  complemento: z.string().nullable(),
  bairro: z.string(),
  estado: z.string().length(2),
  cidade: z.string(),
  dataAgendamento: z.string().datetime(),
  condicoesEspeciais: z.string().nullable(),
  linguaEstrangeira: z.enum(["ingles", "espanhol"]).nullable(),
  nivelEnsino: z.enum(["fundamental", "medio"]),
  criterioSelecao: z.string().optional().nullable(),
  areasConhecimento: z.array(z.string()),
  jaRealizouExame: z.string().optional().nullable(),
  statusAvaliacao: z.enum(["deferida", "indeferida", "pendente"]).nullable(),
  observacoesAvaliacao: z.string().nullable(),
  dataAvaliacao: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  avaliador: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .nullable(),
  faculdade: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .optional()
    .nullable(),
  processo: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .optional()
    .nullable(),
  documentos: z.array(
    z.object({
      id: z.number(),
      tipoDocumento: documentosTiposSchema,
      arquivoCaminho: z.string(),
      arquivoNomeOriginal: z.string(),
    })
  ),
  examesAnteriores: z
    .array(
      z.object({
        exame_nome: z.string(),
        exame_anos: z.string(),
        exame_documento_caminho: z.string(),
        exame_documento_nome_original: z.string(),
        exame_documento_tipo: z.string(),
        exame_documento_tamanho: z.number(),
      })
    )
    .optional()
    .nullable(),
});

export type Enrollment = z.infer<typeof enrollmentSchema>;
